module.exports = __webpack_public_path__ + "img/PriceLists.b2d507f9.svg";